import { saveBirthDraft } from './lib/birthDraft';
import { analyticsLandingPath, trackAnalytics } from './lib/analytics';
import './chartEntry.css';

for (const form of document.querySelectorAll<HTMLFormElement>('[data-chart-entry]')) {
  const system = form.dataset.chartEntry === 'bazi' ? 'bazi' : 'ziwei';
  const context = { chart_system: system, entry_surface: 'quick_form' };
  let started = false;
  form.addEventListener('focusin', () => {
    if (started) return;
    started = true;
    trackAnalytics('chart_form_started', context);
  });
  form.addEventListener('invalid', () => trackAnalytics('chart_form_error', { ...context, error_code: 'invalid_input' }, { dedupeKey: `entry-invalid:${system}` }), true);
  const unknown = form.querySelector<HTMLInputElement>('[data-entry-unknown]');
  const time = form.querySelector<HTMLInputElement>('[data-entry-time]')!;
  form.querySelector<HTMLButtonElement>('button[type=submit]')!.disabled = false;
  unknown?.addEventListener('change', () => { time.disabled = unknown.checked; time.required = !unknown.checked; });
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const error = form.querySelector<HTMLElement>('[data-entry-error]')!;
    try {
      saveBirthDraft(sessionStorage, { version: 1, system, date: form.querySelector<HTMLInputElement>('[data-entry-date]')!.value,
        time: unknown?.checked ? '12:00' : time.value,
        gender: form.querySelector<HTMLSelectElement>('[data-entry-gender]')!.value === 'male' ? 'male' : 'female', timeKnown: !unknown?.checked, createdAt: Date.now() });
      // Fixed same-origin destination; only intent/entry metadata travels in URL.
      const destination = new URL(form.action);
      trackAnalytics('chart_entry_submitted', { ...context, destination: analyticsLandingPath(destination.pathname, destination.search) });
      window.location.assign(form.action);
    } catch {
      trackAnalytics('chart_form_error', { ...context, error_code: 'draft_unavailable' });
      error.textContent = form.dataset.entryError || 'Check your date and time, or open the full calculator below.';
    }
  });
}
